export default "__VITE_ASSET__Y37Hke5c__"